import { theme } from 'antd';

const { useToken } = theme;

const useAntdToken = () => {
  return useToken();
};

export default useAntdToken;
